import React from 'react';
import { Link as GLink } from 'gatsby';

import { LinkButton as AchievableLinkButton } from '@achievable-me/ux';

const LinkButton = (props) => {
  const {
    className,
    children,
    'data-aaa': dataAaa,
    'data-product-slug': dataProductSlug,
    disabled,
    href,
    rel,
    secondary,
    size,
    target,
    theme,
    to,
  } = props;

  return (
    <AchievableLinkButton
      className={className}
      CustomLink={GLink}
      dataAaa={dataAaa}
      dataProductSlug={dataProductSlug}
      disabled={disabled}
      href={href}
      rel={rel}
      secondary={secondary}
      size={size}
      target={target}
      theme={theme}
      to={to}
    >
      {children}
    </AchievableLinkButton>
  );
};

export default LinkButton;
